import React, { useState, useEffect, useCallback } from 'react'
import { Card, CardHeader, CardBody } from 'reactstrap'
import { Button } from 'components/buttons'
import { LoadingIndicator } from 'components/loading'
import { ErrorViewer } from 'components/error'
import { formatCurrency } from 'utils/numberUtilities'
import { format } from 'utils/stringUtilities'
import { getComponentKey } from 'utils/getComponentKey'

import { useStyles } from './item.css'

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#010101']

export const formatters = (localize) => ({
  bottles: (value) => format(localize('dashboard.bottlesFormat'), value),
  prices: (value) => `${formatCurrency({ value })}`
})

export const DashboardItem = ({ title, dataSource, onDataReceived, bodyClassName, children }) => {
  const classes = useStyles()
  const [refreshKey, setRefreshKey] = useState(getComponentKey())
  const [fetching, setFetching] = useState(false)
  const [hasError, setHasError] = useState(false)
  const handleRefresh = useCallback(() => setRefreshKey(getComponentKey()), [])

  useEffect(() => {
    setFetching(true)
    setHasError(false)

    dataSource()
      .then(r => {
        setFetching(false)
        onDataReceived(r)
      })
      .catch(() => {
        setHasError(true)
        setFetching(false)
      })
  }, [refreshKey, dataSource, onDataReceived])
  return (
    <Card className={classes.root}>
      <CardHeader><div className={classes.header}><h4>{title}</h4><Button width={16} className={classes.refreshButton} disabled={fetching} onClick={handleRefresh} icon='refresh' /></div></CardHeader>
      <CardBody className={`${classes.body} ${bodyClassName}`}>
        {fetching && <div className={`${classes.loading} loading`}><LoadingIndicator /></div>}
        {!fetching && !hasError && children}
        {hasError && <ErrorViewer onClick={handleRefresh} />}
      </CardBody>
    </Card>
  )
}